import { cn } from "~/lib/ui";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-stone-900/10 dark:bg-stone-50/10",
        className,
      )}
      aria-label="Loading content"
      role="status"
      aria-live="polite"
      {...props}
    />
  );
}

export { Skeleton };
